import moment from "moment";
import GeoHelper from "../Helpers/GeoHelper";
import VesselProperty from "./Enums/VesselProperty";
import VesselPathConfig from "./VesselPathConfig";

// NOTE:
// Path and Stops are a 1:1 relationship so could be the same Class. There's no reason why they
// aren't if there becomes a reason to join/simplify

// * Downsampling should be done before data is passed to this class *
// reload

class Path {
	constructor(vessel, messages, config = null) {
		if (!messages || messages.length === 0) {
			// console.warn("No message data to build path for mmsi: " + vessel._feature.properties.mmsi);
		}
		this.vessel = vessel;

		if (config === null) {
			config = VesselPathConfig;
		}
		this.config = config;

		if (this.vessel.alertTypes && this.vessel.alertTypes.length > 0) {
			// If live time is AFTER from most recent historic time, add it to the messages list so it's the latest point.
			if (messages.length > 0) {
				const liveTime = vessel.timestamp; // feature.properties[AlertDataProperties.TIMESTAMP];
				const latestHistoricTime = messages[messages.length - 1].properties[VesselProperty.TIMESTAMP];
				if (moment(liveTime).isAfter(moment(latestHistoricTime))) {
					messages.push(this.getMessageFromVessel(vessel.feature));
				}
			}
			else {
				// Always be a min length of 1.
				messages.push(this.getMessageFromVessel(vessel.feature));
			}
		}

		this.stops = new Stops(this, messages, vessel);
	}

	// TODO: consider caching if referenced frequently
	get points() {
		return this.stops._stopArray.map(stop => {
			// console.log("stop", stop, stop.properties[AlertDataProperties.COURSE]);
			const v = {
				...stop,
				properties: {
					...stop.properties
				}
			};
			for (const key in this.config.pointProperties) {
				if (typeof this.config.pointProperties[key] === "function") {
					v.properties[key] = this.config.pointProperties[key](stop);
				}
				else {
					v.properties[key] = stop.properties[key];
				}
			}
			if (this.config.pointLiveGetterProperties) {
				for (const key in this.config.pointLiveGetterProperties) {
					v.properties[key] = this.vessel[key];
				}
			}

			// console.log("points", v);
			// [VesselProperty.NAME]: stop.properties[VesselProperty.NAME],
			// [VesselProperty.IMO]: stop.properties[VesselProperty.IMO],
			// iconImage: (typeof stop.properties[VesselProperty.COURSE] !== "undefined") ? "path-triangle-isosceles" : "dot-11"
			return v;
		});
	}

	// TODO: consider caching
	get line() {
		const allCoords = [];
		this.stops._stopArray.forEach(stop => allCoords.push(stop.geometry.coordinates));
		const lineStringFeature = {
			type: "Feature",
			properties: {
				imo: this.vessel.imo,
				alertTypes: this.vessel.alertTypes,
				lineColor: this.vessel.lineColor
			},
			geometry: {
				type: "LineString",
				coordinates: allCoords
			}
		};
		// TODO: make fixLineWrapAround able to also work with just the coordinates
		return GeoHelper.fixLineWrapAround(lineStringFeature);
	}

	getSnapshotVesselFeature(date) {
		return this.stops.getLastStopByDatetime(date);
	}

	getMessageFromVessel(vesselFeature) {
		// Currently, as liveFeature data has the same property names as
		// historic data. If this changes, we will need different property enums
		// and this method should map between them
		// TODO: extract hard-coded 'fixed' property names as recieved from Vessels
		//  or correct Vessels to only use enum
		const msg = {
			type: "Feature",
			geometry: {
				type: "Point",
				coordinates: vesselFeature.geometry.coordinates
			},
			properties: {

			}
		};
		for (const key in this.config.messageProperties) {
			msg.properties[key] = vesselFeature.properties[key];
		}
		// properties
		// [VesselProperty.MMSI]: vesselFeature.properties[VesselProperty.MMSI],
		// [VesselProperty.TIMESTAMP]: vesselFeature.properties[VesselProperty.TIMESTAMP],
		// [VesselProperty.FLAG]: vesselFeature.properties[VesselProperty.FLAG],
		// [VesselProperty.SPEED]: vesselFeature.properties[VesselProperty.SPEED],
		// [VesselProperty.COURSE]: vesselFeature.properties[VesselProperty.COURSE]
		return msg;
	}

	// TODO: be sure this isn't being used too much as it would be good to avoid oversorting
	// addPointByLiveFeature(liveFeature) {
	// 	const messageFromVessel = this.getMessageFromVessel(liveFeature);
	// 	this.stops.addPoint(messageFromVessel);
	// 	// this.stops.sortPoints();
	// }
}

class Stops {
	constructor(path, messages, vessel) {
		this.path = path;
		this._stopArray = messages;
		this.vessel = vessel;
		this.imo = vessel.imo;
		this.sortPoints();
		this.buildMappings();

		this.sevenDaysBefore = null;
		// this.generateQuickIndex();
	}

	get length() {
		return this._stopArray.length;
	}

	sortPoints() {
		this._stopArray.sort((a, b) => a.timestamp - b.timestamp);
	}

	buildMappings() {
		this.mapTimestampToIndex = {};
		this.mapIndexToTimestamp = {};
		for (let i = 0; i < this._stopArray.length; i++) {
			const stop = this._stopArray[i];
			const timestamp = stop.properties[VesselProperty.TIMESTAMP]; // stop.timestamp;
			this.mapTimestampToIndex[timestamp] = i;
			this.mapIndexToTimestamp[i] = timestamp;
		}
	}

	getIndexForTimestamp(timestamp) {
		return this.mapTimestampToIndex[timestamp];
	}

	getTimestampForIndex(index) {
		return this.mapIndexToTimestamp[index];
	}

	getPropertyForIndex(index, vesselProperty) {
		return this._stopArray[index].properties[vesselProperty];
	}

	/* getHourSlot(timestamp) {
		return Math.floor((timestamp.valueOf() - this.sevenDaysBefore.valueOf()) /
			(60 * 60 * 1000));
	}

	// Generates an array of hour slots with the index from this.points with the max time in that hour
	generateQuickIndex() {
		this.quickIndex = [];
		// TODO: create automatic way for using date override to keep dummy data in 7 day range
		// Change this to null in prod!
		const nowDateOverride = get(AlertsStore.meta.nowTimeOverride);
		if (nowDateOverride) {
			console.warn("NowDateOverride active in alersstore! If not in test this is an error");
		}
		const baseDate = nowDateOverride || new Date();

		this.sevenDaysBefore =
			new Date((baseDate || new Date()).valueOf() - 1000 * 60 * 60 * 24 * 7);

		for (let i = 0; i < this._stopArray.length; i++) {
			const point = this._stopArray[i];
			const timestamp = new Date(point.properties[AlertDataProperties.TIMESTAMP]);
			this.quickIndex[this.getHourSlot(timestamp)] = i;
		}
	}

	get MaxDatetime() {
		return new Date(this._stopArray[this._stopArray.length - 1].properties[AlertDataProperties.TIMESTAMP]);
	}*/

	// To add point after initialisation
	addPoint(message) {
		this._stopArray.push(message);
		this.sortPoints();
		this.buildMappings();
		// this.generateQuickIndex();
	}

	getNextStopByDatetime(snapshotDatetime) {

	}

	getLastStopByDatetime(snapshotDatetime) {
		// TODO Re-implement quick index or remove the unnecessarry supporting functions

		// let hourSlot = this.getHourSlot(datetime);
		// for (hourSlot; hourSlot >= 0; hourSlot--) {
		// 	const startIndex = this.quickIndex[hourSlot];
		// 	if (startIndex) {
		// 		for (let i = startIndex; i >= 0; i--) {
		// 			const timeStamp = new Date(this._stopArray[i].properties[AlertDataProperties.TIMESTAMP]);
		// 			if (timeStamp <= datetime) {
		// 				return this._stopArray[i];
		// 			}
		// 		}
		// 		return false;
		// 	}
		// }
		// return false;

		// Unoptimised; iterates through entire list from earliest

		let initialVal = 0;
		let incrementVal = 1;
		let limitCheck = (index) => {
			return index < this._stopArray.length;
		};
		if (this.path.config.historicOrder === -1) {
			initialVal = this._stopArray.length - 1;
			incrementVal = -1;
			limitCheck = (index) => {
				return index >= 0;
			};
		}

		const snapshotDatetimeMoment = moment(snapshotDatetime);
		for (let i = initialVal; limitCheck(i); i += incrementVal) {
			const stop = this._stopArray[i];
			const stopDatetimeMoment = moment(stop.properties[VesselProperty.TIMESTAMP]);
			if (snapshotDatetimeMoment.isSameOrAfter(stopDatetimeMoment)) {
				return stop;
			}
		}
		// No valid snapshot position
		return false;
	}
}

export default Path;

/*
//////////////////////////////////////////////////////////
//														//
// 	~ Example historic point message for reference ~	//
//	{													//
//		"type": "Feature",								//
//		"geometry": {									//
//			"type": "Point",							//
//			"coordinates": [126.46488, 37.335]			//
//		},												//
//		"properties": {									//
//			"imo": 1234567,								//
//			"mmsi": 111111111,							//
//			"time_stamp": "2020-03-27T20:47:46",		//
//			"Flag": "PA",								//
//			"Classification": "",						//
//			"Speed": 11.2,								//
//			"Draught": "11.9",							//
//			"Name": "SOME VESSEL NAME",					//
//			"voyage_dest": "TIMBUKTU",					//
//			"voyage_eta": "2020-03-27T02:00:00",		//
//			"Course": 54.0								//
//		},												//
//		"update": 20.854166666666668					//
//	}													//
//														//
//////////////////////////////////////////////////////////
*/
